import React from 'react';
import PropTypes from 'prop-types';
import { withModal, YoutubePlayer } from '@sm360/widget-commons-general';
import 'commons-vehicle/Vehicle/components/VehicleBannerWithCarrousel/Video/Video.scss';

const MODAL = 'VehicleBanner/VehicleVideo';

const Video = ({ videoURL, modal }) => {
    return (
        <div className="VehicleVideoModal">
            <button onClick={modal.close}>
                <icon className="icon-X-rouge" />
            </button>
            <YoutubePlayer videoURL={videoURL} autoplay={1} />
        </div>
    );
};

Video.propTypes = {
    videoURL: PropTypes.string.isRequired,
    modal: PropTypes.shape.isRequired,
};

Video.displayName = 'VehicleVideoModal';

export { Video };
export default withModal(MODAL)(Video);
